{
  "name": "playcocola-client",
  "version": "3.22.0",
  "private": true,
  "engines": {
    "node": ">=22.12"
  },
  "scripts": {
    "dev": "vite",
    "dev:mock": "vite --open \"/?playtest_round_api_url=/__mock/rich/playtest_round&api_token=mock\"",
    "start": "vite",
    "build": "vite build",
    "build:dev": "vite build --minify false",
    "preview": "vite preview",
    "test": "playwright test",
    "test:headed": "playwright test --headed",
    "test:ui": "playwright test --ui",
    "test:why": "SHOW_EXPECTED_FAILURES=1 playwright test",
    "test:report": "playwright show-report"
  },
  "dependencies": {
    "@fontsource/nunito": "5.3.0",
    "@popperjs/core": "2.11.8",
    "axios": "1.20.0",
    "bootstrap": "5.3.8",
    "bootstrap-icons": "1.13.1",
    "dompurify": "3.4.16",
    "js-cookie": "3.0.8",
    "marked": "18.1.0",
    "party-js": "2.2.0",
    "ua-parser-js": "1.0.41"
  },
  "devDependencies": {
    "@playwright/test": "^1.63.0",
    "vite": "^8.3.3"
  }
}
